<template>
    <main-content>
        <kt-panel>
            <kt-panel-body>
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active"
                           data-toggle="pill"
                           href="#pills-stakeholder"
                           id="pills-stakeholder-tab"
                           role="tab"
                        >
                            {{ $t('settlement.label.settlement_to_stakeholder_request') }}
                        </a>
                    </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-stakeholder" role="tabpanel">
                        <form @submit.prevent="submit_stakeholder_form" id="stakeholder_form">
                            <div class="row">
                                <div class="col-12 col-md-6 my-3">
                                    <label for="shop_hashid" v-text="$t('label.gateway')">
                                    </label>
                                    <select
                                            @change="load_shop_enabled_stakeholders"
                                            class="form-control"
                                            id="shop_hashid"
                                            name="shop_hashid"
                                            v-model="shop_hashid"
                                    >
                                        <option :key="index"
                                                :value="shop.id"
                                                v-for="(shop, index) in user_shops"
                                        >
                                            {{ shop.title }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-12 col-md-6 my-3" v-show="shop_hashid != null">
                                    <label for="stakeholder_hashid" v-text="$t('label.stakeholder')">
                                    </label>
                                    <select
                                            @change="load_sheba_numbers"
                                            class="form-control"
                                            id="stakeholder_hashid"
                                            name="stakeholder_hashid"
                                            v-model="stakeholder_hashid"
                                    >
                                        <option :key="index"
                                                :value="stakeholder.id"
                                                v-for="(stakeholder, index) in shop_stakeholders"
                                        >
                                            {{ stakeholder.full_name }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-12 col-md-6 my-3" v-show="stakeholder_hashid != null">
                                    <label for="sheba_number_hashid" v-text="$t('label.sheba_number')">
                                    </label>
                                    <select
                                            class="form-control"
                                            id="sheba_number_hashid"
                                            name="sheba_number_hashid"
                                            v-model="sheba_number_hashid"
                                    >
                                        <option :key="index"
                                                :value="sheba_number.id"
                                                v-for="(sheba_number, index) in sheba_numbers"
                                        >
                                            {{ sheba_number.number }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-12 col-md-6 my-3" v-show="stakeholder_hashid != null">
                                    <label for="amount" v-text="$t('label.amount_rial')">
                                    </label>
                                    <input
                                            class="form-control"
                                            id="amount"
                                            name="amount"
                                            v-model="amount"
                                    >
                                </div>
                            </div>
                            <div class="mt-4 mb-2">
                                <button class="btn btn-success" type="submit" v-text="$t('btn.create')"></button>
                            </div>
                        </form>
                    </div>
                </div>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content';
    import $ from "jquery";
    import {gatewayService, settlementService, stakeholdersService} from "@/common/api.service";

    export default {
        components: {
            mainContent,
        },
        data() {
            return {
                form_data: {},
                user_shops: [],
                shop_hashid: null,
                shop_stakeholders: [],
                stakeholder_hashid: null,
                sheba_numbers: [],
                sheba_number_hashid: null,
                amount: 1,
                w_shop_hashid: null,
                wallet_hashid: null,
                wallet_amount: 1,
            };
        },
        mounted() {
            this.load_user_shops();
        },
        methods: {
            load_user_shops() {
                gatewayService.get_payment_helper_shops().then(response => {
                    this.user_shops = response.data.data;
                });
            },
            load_shop_enabled_stakeholders() {
                this.stakeholder_hashid = null;
                this.shop_stakeholders = [];

                stakeholdersService.get_shop_enabled_stakeholders(this.shop_hashid).then(response => {
                    this.shop_stakeholders = response.data.data;
                });
            },
            load_sheba_numbers() {
                this.sheba_number_hashid = null;
                this.sheba_numbers = [];

                for (let item of this.shop_stakeholders) {
                    if (item.id === this.stakeholder_hashid) {
                        this.sheba_numbers = item.sheba_numbers;
                    }
                }
            },
            submit_stakeholder_form() {
                let form = $('#stakeholder_form');

                form.validate({
                    rules: {
                        shop_hashid: {
                            required: true,
                        },
                        stakeholder_hashid: {
                            required: true,
                        },
                        amount: {
                            required: true,
                        },
                        sheba_number_hashid: {
                            required: true,
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                let params = {
                    shop_hashid: this.shop_hashid,
                    stakeholder_hashid: this.stakeholder_hashid,
                    sheba_number_hashid: this.sheba_number_hashid,
                    amount: this.amount,
                };

                settlementService.createSettlementRequestForStakeholder(params).then(response => {
                    this.$router.push('/settlements');
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                });
            },
            submit_wallet_form() {
                let form = $('#wallet_form');

                form.validate({
                    rules: {
                        wallet_hashid: {
                            required: true,
                        },
                        amount: {
                            required: true,
                        },
                        shop_hashid: {
                            required: true,
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                let params = {
                    wallet_hashid: this.wallet_hashid,
                    amount: this.wallet_amount,
                    shop_hashid: this.w_shop_hashid,
                };

                settlementService.createSettlementRequestForWallet(params).then(response => {
                    this.$router.push('/settlements');
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                });
            }
        },
    }
</script>
